"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newTagInput = exports.TagInputBase = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var getClassNames = (0, _react2.classNamesFunction)();
/**
 * Extension class to expose some protected values as public.
 * Based off of TagPickerBase but extends from BasePicker to allow extension of props.
 *
 * A large amount of this customization and overriding is because the TagPicker allows
 * customization of individual suggestion rows, but not of the entire dropdown itself.
 * Since we want a tree explorer and not a simple list, this extension class is created
 * to enable that.
 *
 * This class is called Tag**Input**Base rather than some variation of TagPickerBase because
 * it focuses just on the <input/> component and the tags that go inside of it. The
 * dropdown / popup experience that shows up to show suggestions (whether it be a list
 * or a tree) is not handled in class as it is in TagPickerBase, but rather, handled externally as a
 * separate component, in our case, the <ServiceTreeSelector/>.
 */
var TagInputBase = /*#__PURE__*/function (_BasePicker) {
  _inherits(TagInputBase, _BasePicker);
  var _super = _createSuper(TagInputBase);
  function TagInputBase(props) {
    var _this;
    _classCallCheck(this, TagInputBase);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onInputValueChange", function (newValue, _) {
      newValue && _this.onInputChange(newValue);
    });
    _defineProperty(_assertThisInitialized(_this), "onEscape", function (e) {
      e.stopPropagation();
      _this.focusInput();
      _this.props.focusedElementsDispatch({
        type: "clear"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (_this.props.disabled) {
        return;
      }
      var focusedElementsDispatch = _this.props.focusedElementsDispatch;
      focusedElementsDispatch({
        type: "add",
        payload: "tagInput"
      });
      if (e.keyCode === _react2.KeyCodes.escape) {
        _this.onEscape(e);
      } else if (e.keyCode === _react2.KeyCodes.backspace || e.keyCode === _react2.KeyCodes.del) {
        _this.onBackspace(e);
      } else if (e.keyCode === _react2.KeyCodes.tab) {
        focusedElementsDispatch({
          type: "delete",
          payload: "tagInput"
        });
      } else if (e.keyCode === _react2.KeyCodes.down) {
        e.preventDefault();
        var element = _this.firstVisibleTreeRow();
        element === null || element === void 0 ? void 0 : element.focus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "firstVisibleTreeRow", function () {
      var container = document.getElementById("st-container");
      var rows = Array.from(document.querySelectorAll("#st-container tr.bolt-tree-row"));
      if (container === null || rows.length === 0) {
        return null;
      }
      var rowHeight = rows[0].getBoundingClientRect().height;
      var leeway = rowHeight / 2;
      for (var _i = 0, _rows = rows; _i < _rows.length; _i++) {
        var row = _rows[_i];
        if (row.getBoundingClientRect().y + leeway > container.getBoundingClientRect().y) {
          return row;
        }
      }
      return rows[0];
    });
    (0, _react2.initializeComponentRef)(_assertThisInitialized(_this));
    _this.state = _objectSpread(_objectSpread({}, _this.state), {}, {
      suggestionsVisible: props.showPicker
    });
    return _this;
  }
  _createClass(TagInputBase, [{
    key: "clearInput",
    value: function clearInput() {
      var _this$input$current;
      (_this$input$current = this.input.current) === null || _this$input$current === void 0 ? void 0 : _this$input$current.clear();
    }

    /**
     * Forcibly override the aria-autocomplete value of the internal <Autofill/>
     * component since it does not allow a prop for overriding it
     */
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$input$current2, _this$input$current2$;
      (_this$input$current2 = this.input.current) === null || _this$input$current2 === void 0 ? void 0 : (_this$input$current2$ = _this$input$current2.inputElement) === null || _this$input$current2$ === void 0 ? void 0 : _this$input$current2$.setAttribute("aria-autocomplete", "none");
    }

    /**
     * A majority of the code for this render function was copied from the source:
     * https://github.com/microsoft/fluentui/blob/8b3ec363d98ae8597bc4b94577df71ab8cd94cd5/packages/react/src/components/pickers/BasePicker.tsx#L277
     *
     * Changes:
     *      - Moved aria stuff from <FocusZone/> into a new parent <div/>
     *      - aria-expanded property is controlled by this.props.showTreePicker instead of this.state.showSuggestions
     *      - Replaced call to {this.renderSuggestions()} with this.props.renderDialog()
     *      - Add legacyStyles to props destructuring
     *      - Any changes to meet linter preferences of our project
     *      - Added aria-controls property to reference the popup dialog: https://dev.azure.com/mseng/1ES/_workitems/edit/1835132/
     */
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        suggestedDisplayValue = _this$state.suggestedDisplayValue,
        isFocused = _this$state.isFocused,
        items = _this$state.items;
      var _this$props = this.props,
        className = _this$props.className,
        inputProps = _this$props.inputProps,
        disabled = _this$props.disabled,
        theme = _this$props.theme,
        legacyStyles = _this$props.legacyStyles,
        styles = _this$props.styles;
      var selectedSuggestionAlertId = this.props.enableSelectedSuggestionAlert ? this._ariaMap.selectedSuggestionAlert : "";
      var suggestionsAvailable = this.state.suggestionsVisible ? this._ariaMap.suggestionList : "";
      var canAddItems = this.canAddItems();
      var classNames = styles ? getClassNames(styles, {
        theme: theme,
        className: className,
        isFocused: isFocused,
        disabled: disabled,
        inputClassName: inputProps === null || inputProps === void 0 ? void 0 : inputProps.className
      }) : {
        root: (0, _react2.css)("ms-BasePicker", className ? className : ""),
        text: (0, _react2.css)("ms-BasePicker-text", legacyStyles.pickerText, this.state.isFocused && legacyStyles.inputFocused),
        itemsWrapper: legacyStyles.pickerItems,
        input: (0, _react2.css)("ms-BasePicker-input", legacyStyles.pickerInput, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className),
        screenReaderText: legacyStyles.screenReaderOnly
      };
      return /*#__PURE__*/React.createElement("div", {
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props -- since it is provided from `this.props.renderDIalog()`
        role: "combobox",
        "aria-expanded": canAddItems ? isFocused : undefined,
        "aria-label": canAddItems ? this.props["aria-label"] : undefined,
        "aria-owns": canAddItems ? suggestionsAvailable || undefined : undefined,
        "aria-haspopup": suggestionsAvailable && this.suggestionStore.suggestions.length > 0 ? "listbox" : "dialog",
        id: canAddItems ? this._ariaMap.combobox : undefined,
        "aria-controls": "service-tree-picker-dialog"
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.root,
        role: "presentation",
        className: classNames.root,
        onKeyDown: this.onKeyDown,
        onBlur: this.onBlur
      }, /*#__PURE__*/React.createElement(_react2.FocusZone, {
        direction: _react2.FocusZoneDirection.bidirectional,
        shouldEnterInnerZone: this._shouldFocusZoneEnterInnerZone
      }, this.getSuggestionsAlert(classNames.screenReaderText), /*#__PURE__*/React.createElement(_react2.SelectionZone, {
        selection: this.selection,
        selectionMode: _react2.SelectionMode.multiple
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames.text,
        role: "presentation"
      }, items.length > 0 && /*#__PURE__*/React.createElement("span", {
        id: this._ariaMap.selectedItems,
        className: classNames.itemsWrapper,
        role: "list"
      }, this.renderItems()), this.canAddItems() && /*#__PURE__*/React.createElement(_react2.Autofill, _extends({
        spellCheck: false
      }, inputProps, {
        className: classNames.input,
        componentRef: this.input,
        onClick: this.onClick,
        onFocus: this.onInputFocus,
        onBlur: this.onInputBlur,
        onInputValueChange: this.onInputValueChange,
        suggestedDisplayValue: suggestedDisplayValue,
        "aria-describedby": items.length > 0 ? this._ariaMap.selectedItems : undefined,
        "aria-controls": "".concat(suggestionsAvailable, " ").concat(selectedSuggestionAlertId) || undefined,
        "aria-activedescendant": this.state.suggestionsVisible ? this.getActiveDescendant() : "",
        "aria-labelledby": this.props["aria-label"] ? this._ariaMap.combobox : undefined,
        role: "textbox",
        disabled: disabled,
        onInputChange: this.props.onInputChange
      })))))), this.props.renderDialog());
    }

    /**
     * Capture the escape event to close the tree picker instead of the entire panel
     */

    /**
     * See for more details: https://mseng.visualstudio.com/1ES/_boards/board/t/BMV%20-%20Team/Stories/?workitem=1819626
     *
     * Since tree items may be virtualized, this functions finds the first node that is materialized and
     * reasonably visible (per the leeway variable).
     */
  }]);
  return TagInputBase;
}(_react2.BasePicker);
/**
 * `getStyles` is internal library code so the import does not play well
 * when running tests. Inject the dependency using `newTagInput`
 * so that it can be easily mocked for tests, and used easily in production code.
 */
exports.TagInputBase = TagInputBase;
_defineProperty(TagInputBase, "defaultProps", _react2.TagPickerBase.defaultProps);
var StyledTagInput = function StyledTagInput(getStyles, legacyStyles) {
  return (0, _react2.styled)(TagInputBase, getStyles, function (props) {
    return _objectSpread(_objectSpread({}, props), {}, {
      legacyStyles: legacyStyles
    });
  }, {
    scope: "TagPicker"
  });
};
var newTagInput = function newTagInput() {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  var Styles = require("@fluentui/react/lib/components/pickers/BasePicker.styles");
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  var legacyStyles = require("@fluentui/react/lib/components/pickers/BasePicker.scss");
  return StyledTagInput(Styles.getStyles, legacyStyles);
};
exports.newTagInput = newTagInput;